"use client";

import React, { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export function PointerHighlight({
  children,
  className = "",
  rectangleClassName = "bg-neutral-200 dark:bg-neutral-700 border-neutral-300 dark:border-neutral-600",
  pointerClassName = "text-yellow-500"
}) {
  const [isHovered, setIsHovered] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const ref = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (ref.current) {
        const rect = ref.current.getBoundingClientRect();
        setMousePosition({
          x: e.clientX - rect.left,
          y: e.clientY - rect.top,
        });
      }
    };

    const element = ref.current;
    if (element) {
      element.addEventListener("mousemove", handleMouseMove);
      return () => element.removeEventListener("mousemove", handleMouseMove);
    }
  }, []);

  return (
    <span
      ref={ref}
      className={`relative inline-block cursor-pointer ${className}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <AnimatePresence>
        {isHovered && (
          <>
            {/* Background Rectangle */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              className={`absolute inset-0 rounded-lg border ${rectangleClassName}`}
              style={{ zIndex: 1 }}
            />
            
            {/* Pointer */}
            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              animate={{ 
                opacity: 1, 
                scale: 1,
                x: mousePosition.x,
                y: mousePosition.y - 30
              }}
              exit={{ opacity: 0, scale: 0 }}
              transition={{ 
                type: "spring", 
                stiffness: 300, 
                damping: 20 
              }}
              className={`absolute pointer-events-none ${pointerClassName}`}
              style={{ 
                zIndex: 3,
                left: -10,
                top: -10
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="transform -rotate-12"
              >
                <path d="M7.5 14.25c0-0.414 0.336-0.75 0.75-0.75h3.75v-3.75c0-0.414 0.336-0.75 0.75-0.75s0.75 0.336 0.75 0.75v3.75h3.75c0.414 0 0.75 0.336 0.75 0.75s-0.336 0.75-0.75 0.75h-3.75v3.75c0 0.414-0.336 0.75-0.75 0.75s-0.75-0.336-0.75-0.75v-3.75h-3.75c-0.414 0-0.75-0.336-0.75-0.75z" />
              </svg>
            </motion.div>
          </>
        )}
      </AnimatePresence>
      
      {/* Content */}
      <span className="relative z-10">
        {children}
      </span>
    </span>
  );
}

export default PointerHighlight;